<template>
  <div>
    <!--タイトル-->
    <header id="header">
      <Header title-image="static/images/common/logo-question.svg" can-back-flag="0"></Header>
    </header>

    <!--結果-->
    <div id="wrapper">
      <div class="content">
        <div class="result-box">
          <h3 class="ttl">結果</h3>
          <p>間違いを確認しよう<br>解答をタップすると問題が表示されます</p>
        </div>
        <div class="result-list-box">
          <ul style="margin-bottom: 160px;">
              <li v-for='row in ngTitle' v-bind:key='row.id'>
                <a href='#' :id='row.id' data-remodal-target="modalDetail" v-on:click.prevent='linkAction' v-html="row.answer"></a>
              </li>
          </ul>
        </div>

        <!-- 詳細 -->
        <div id="detailPopup" data-remodal-id="modalDetail" class="remodal modal-result-box" data-remodal-options="hashTracking:false">
          <div class="modal-content">
            <div class="btn-close-box">
              <button data-remodal-action="close" type="button" class="btn btn-close"><img src="static/images/common/btn/btn-close.svg" alt="閉じる"></button>
            </div>
            <div class="text-box">
              <p v-html="question"></p>
              <h4 class="ttl" v-html="answer"></h4>
            </div>
          </div>
        </div>

      </div>
    </div>
    
    <footer id="footer">
      <div class="footer-box">
        <div class="question-result-footer">
          <p>{{totalCount}}問中<br><span>{{ngTitle.length}}問不正解</span></p>
        </div>
        <div class="question-answer-footer">
          <div class="box-l">
            <button type="button" class="btn btn-unit-l" data-remodal-target="confirmModal2"><img src="static/images/common/btn/btn-unit-l.svg" alt="単元選択へ"></button>
          </div>
          <div class="box-r">
            <button type="button" class="btn btn-top" data-remodal-target="confirmModal"><img src="static/images/common/btn/btn-top.svg" alt="トップ画面へ"></button>
          </div>
        </div>
      </div>
    </footer>   
    
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Header from '@/components/modules/Header'
import cmd from '@/common/Command'

export default {
  data: function () {
    return {
      selectedQuestion: "",
      selectedAnswer: "",
    }
  },
  mounted: function () {
    $("body").removeClass()
    $("body").addClass("page-low")
    $("body").addClass("cat-question")
    $("body").addClass("page-question-result")    
    cmd.adjustStyle()

    //モーダルライブラリを読み込み
    //cmd.loadRemodal()
  },
  methods: {
    ...mapActions('QuestionModule', {
    }),
    linkAction (e) {
      var element = e.currentTarget
      var id = element.getAttribute('id')

      var self = this
      $.each(this.ngTitle, function(idx, row){
        if (row.id == id) {
          self.question = row.question
          self.answer = row.answer
          return false
        }
      })
    
      //$('#detailPopup').modal()
      //$('#detailPopup').remodal()
      //$('[data-remodal-id=modal1]').remodal();
    },
    closePopup (e) {
      //$('#detailPopup').modal('hide')
    }
    
    
  },
  computed: {
    ...mapGetters('QuestionModule', [      
      'totalCount',
      'ngTitle'
    ]),
    question: {
      get () {
        return this.selectedQuestion
      },
      set (value) {
        this.selectedQuestion = value
      }
    },
    answer: {
      get () {
        return this.selectedAnswer
      },
      set (value) {
        this.selectedAnswer = value
      }
    },
  },
  components: {
    Header
  }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/QuestionResult.vue